var exports = {
  "Q": "PendingFriendsView.module__pendingViewContainer___MGxXN1",
  "X": "PendingFriendsView.module__scroller___MGxXN1",
};

module.exports = exports;
